import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DesignCrossesContext } from './design-crosses.context';
import { JhiEventManager } from '../shared/core-utils';
import { CrossService } from '../shared/study/service/cross.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PreviewCrossesModel } from '../shared/study/model/preview-crosses.model';
import { GermplasmDto } from '../shared/germplasm/model/germplasm.model';
import { GermplasmDetailsPopupService } from '../germplasm-details/germplasm-details-popup.service';
import { GermplasmDetailsUrlService } from '../shared/germplasm/service/germplasm-details.url.service';

@Component({
    selector: 'jhi-existing-crosses-modal',
    templateUrl: './existing-crosses.modal.component.html',
})
export class ExistingCrossesModalComponent implements OnInit {

    previewCross: PreviewCrossesModel;
    completeExistingCrossesList: GermplasmDto[];
    listPerPage: GermplasmDto[][];
    currentPagePreviewList: GermplasmDto[];
    totalItems: number;
    currentPageCount: number;
    page = 1;
    itemsPerPage = 10;
    isLoading = false;
    previousPage: number;

    constructor(private route: ActivatedRoute,
                private context: DesignCrossesContext,
                private eventManager: JhiEventManager,
                private crossService: CrossService,
                public activeModal: NgbActiveModal,
                protected germplasmDetailsPopupService: GermplasmDetailsPopupService,
                private germplasmDetailsUrlService: GermplasmDetailsUrlService) {
    }

    ngOnInit() {
        this.previewCross = this.context.cross;
        const maleGids = [];
        this.previewCross.maleParents.forEach((maleParent) => {
            maleGids.push(maleParent.gid);
        });

        const femaleGids = [];
        this.previewCross.femaleParents.forEach((femaleGid) => {
            femaleGids.push(femaleGid.gid);
        });
        const existingCrossesPromise = this.crossService.getExistingCrosses(femaleGids, maleGids).toPromise();
        existingCrossesPromise.then((existingCrosses) => {
            this.completeExistingCrossesList = existingCrosses;
            this.processPagination();
            this.loadPage(1, true);
        });
    }

    close() {
        this.activeModal.close('cancel');
    }

    loadPage(page: number, forceReload = false) {
        if (page !== this.previousPage || forceReload) {
            this.previousPage = page;
            this.currentPagePreviewList = this.listPerPage[page - 1];
            const itemCount = this.currentPagePreviewList.length;
            this.currentPageCount = ((page - 1) * this.itemsPerPage) + itemCount;
        }
    }

    resetTable(): void {
        this.page = 1;
        this.previousPage = 1;
        this.listPerPage = [];
        this.processPagination();
        this.loadPage(1, true);
    }

    processPagination() {
        this.totalItems = this.completeExistingCrossesList.length;

        if (this.totalItems === 0) {
            this.listPerPage = [];
            this.listPerPage.push([]);
            return;
        }

        this.listPerPage = this.completeExistingCrossesList.reduce((resultArray, item, index) => {
            const pageIndex = Math.floor(index / this.itemsPerPage);

            if (!resultArray[pageIndex]) {
                resultArray[pageIndex] = []; // start a new page
            }

            resultArray[pageIndex].push(item);

            return resultArray;
        }, []);
    }

    openGermplasmDetailsInTab(gid: number) {
        const url = this.germplasmDetailsUrlService.getUrlAsString(gid);
        window.open(url, '_blank');
    }

}
